// ─── Payload ─────────────────────────────────────────────────────────────────

export interface SegregacaoCalcularPayload {
  CnpjContribuinte: string;
  Ano: string;
  Mes: string;
  RevisaoPropria: 'N' | 'S';
  Recuperacao: 'S';
  Forcar?: 'S' | 'N';
}

export interface SegregacaoDetalharPayload {
  CNPJ_Contribuinte: string;
  Ano: string;
  Mes: string;
  LinhaSegregada: string;
}

// ─── Linhas de Receita / Imposto ─────────────────────────────────────────────

export interface SegregacaoLinhaReceita {
  Linha: string;
  Receita_Bruta: number;
  Devolução: number;
  Receita_Liquida: number;
  COFINS: number;
  CSLL: number;
  ICMS: number;
  INSS: number;
  IRPJ: number;
  PIS: number;
}

export type Ris = SegregacaoLinhaReceita;
export type Ric = SegregacaoLinhaReceita;
export type Rex = SegregacaoLinhaReceita;
export type Iis = SegregacaoLinhaReceita;
export type Iic = SegregacaoLinhaReceita;
export type Iex = SegregacaoLinhaReceita;

// ─── Totais ──────────────────────────────────────────────────────────────────

export interface SegregacaoTot {
  Total_Saidas: number;
  Total_Cancelados: number;
  Total_NaoGeradorReceita: number;
  Total_Faturamento: number;
  Total_NaoSegregado: number;
  Total_Segregado: number;
  Total_EmRevisao: number;
}

// ─── Produtos ────────────────────────────────────────────────────────────────

export interface SegregacaoNgr {
  Produto: string;
  EAN: string;
  Descricao: string;
  Status: string;
  NCM: string;
  COD_MOD: string;
  cenSegregacaoSNAC: string;
  CFOP: string;
  SaidaCST: string;
  CSTPisSaida: string;
  SaidaCSTECF: string;
  ValTot: number;
  ChaveAcessoDOC: string;
}

export interface SegregacaoIgn {
  Produto: string;
  EAN: string;
  Descricao: string;
  Status: string;
  NCM: string;
  COD_MOD: string;
  cenSegregacaoSNAC: string;
  CFOP: string;
  SaidaCST: string;
  CSTPisSaida: string;
  SaidaCSTECF: string;
  ValTot: number;
  ChaveAcessoDOC: string;
  DataInclusao: string;
}

export interface SegregacaoRev {
  Produto: string;
  EAN: string;
  Descricao: string;
  ProdutoReferencialSPED: string;
  Status: string;
  NCM: string;
  ValTot: number;
  DataInclusao: string;
  ChaveAcessoDOC?: string;
}

export interface SegregacaoAlterarStatusPayload {
  CNPJContribuinte: string;
  ChaveAcesso: string;
  Status: string;
}

export interface SegregacaoSeg {
  Produto: string;
  EAN: string;
  Descricao: string;
  ProdutoReferencialSPED: string;
  Status: string;
  NCM: string;
  COD_MOD: string;
  cenSegregacaoSNAC: string;
  CFOP: string;
  SaidaCST: string;
  CSTPisSaida: string;
  SaidaCSTECF: string;
  ValTot: number;
  ChaveAcessoDOC: string;
  TipoItem: string;
  IDSegmento: string;
  DataInclusao: string;
}

// ─── Redução / Recuperação ───────────────────────────────────────────────────

export interface SegregacaoRed {
  CNPJ_Contribuinte: string;
  Ano: string;
  Mes: string;
  Tributo: string;
  IRPJ: number;
  CSLL: number;
  Cofins: number;
  PIS: number;
  CPP: number;
  ICMS: number;
  IPI: number;
  AliquotaEfetiva: number;
}

export interface SegregacaoRec {
  Status: string;
  ValTotExterno: number;
  ValTotInterno: number;
  ReceitaComST: number;
  ReceitaSemST: number;
}

// ─── Linha detalhe (Segregacao/Detalhar) ─────────────────────────────────────

export interface SegregacaoDetalheItem {
  ChaveAcessoDOC: string;
  EAN: string;
  Produto: string;
  NCM: string;
  Descricao: string;
  CNPJEmitente: string;
  CNPJDest: string;
  CFOP: string;
  ValorProd: string;
  ValorFrete: string;
  ValorOutro: string;
  ValorDesc: string;
  vRatAcr: string;
  ValTot: string;
}

// ─── Response principal ──────────────────────────────────────────────────────

export interface SegregacaoCalcularResponseData {
  RIS: Ris[];
  RIC: Ric[];
  REX: Rex[];
  IIS: Iis[];
  IIC: Iic[];
  IEX: Iex[];
  TOT: SegregacaoTot[];
  NGR: SegregacaoNgr[];
  IGN: SegregacaoIgn[];
  REV: SegregacaoRev[];
  SEG: SegregacaoSeg[];
  CHV: SegregacaoSeg[];
  ITM: SegregacaoSeg[];
  REC: SegregacaoRec[];
  RED: SegregacaoRed[];
  produtosRevisao: unknown[];
}

export interface SegregacaoCalcularResponse {
  status: { resultado: boolean; mensagem: string };
  data: SegregacaoCalcularResponseData;
}

export interface SegregacaoDetalharResponse {
  status: { resultado: boolean; mensagem: string };
  data: SegregacaoDetalheItem[];
}

// ─── Phase 4 — DetalharAgrupado + XMLs Convertidos ───────────────────────────

export interface SegregacaoDetalharAgrupadoPayload {
  Cnpj_Contribuinte: string;
  Ano: string;
  Mes: string;
}

export interface SegregacaoDetalharAgrupadoItem {
  CNPJ_Contribuinte: string;
  Ano: string;
  Mes: string;
  Produto: string;
  Descricao: string;
  EAN: string;
  NCM: string;
  ValTot: number;
  LinhaSegregada: string;
  ICMS: string;
  COFINS: string;
  PIS: string;
}

export interface XmlConvertidoPayload {
  CnpjContribuinte: string;
  Ano: string;
  Mes: string;
}

export interface XmlConvertidoItem {
  ID: number;
  Status: string;
  StatusDescricao: string;
  CNPJ_Contribuinte: string;
  Ano: string;
  Mes: string;
  ChaveAcessoDOC: string;
  Serie: string;
  Numero: string;
  DataEmissao: string;
  Valor: number;
}

// ─── Status de produto ───────────────────────────────────────────────────────

export type StatusProduto = 'X' | 'XM' | 'A' | '9' | '2' | '3' | '4' | '5' | '7' | '8';

export interface StatusProdutoInfo {
  label: string;
  descricao: string;
  color: string;
}

export const STATUS_PRODUTO_LABEL: Record<StatusProduto, StatusProdutoInfo> = {
  X: { label: 'Sem EAN', descricao: 'Produto sem EAN ou EAN inválido', color: 'bg-gray-500' },
  XM: { label: 'Não Identificado', descricao: 'Produto não identificado', color: 'bg-gray-400' },
  A: { label: 'Pendente IA', descricao: 'Pendente de associação pela IA', color: 'bg-yellow-500' },
  '9': { label: 'Não Associado', descricao: 'Não associado pela IA', color: 'bg-red-500' },
  '2': { label: 'Em Revisão', descricao: 'Em revisão manual', color: 'bg-orange-500' },
  '3': { label: 'Revisado', descricao: 'Revisado', color: 'bg-blue-500' },
  '4': { label: 'Manual', descricao: 'Revisado manualmente', color: 'bg-indigo-500' },
  '5': { label: 'Por IA', descricao: 'Revisado pela IA', color: 'bg-purple-500' },
  '7': { label: 'Por NCM', descricao: 'Revisado por NCM', color: 'bg-cyan-500' },
  '8': {
    label: 'Automático',
    descricao: 'Revisado por associação automática',
    color: 'bg-teal-500',
  },
};
